import { render, staticRenderFns } from "./textAdd.vue?vue&type=template&id=82da466c&scoped=true&"
import script from "./textAdd.vue?vue&type=script&lang=js&"
export * from "./textAdd.vue?vue&type=script&lang=js&"
import style0 from "./textAdd.vue?vue&type=style&index=0&lang=less&"
import style1 from "./textAdd.vue?vue&type=style&index=1&id=82da466c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82da466c",
  null
  
)

export default component.exports